import script from "./ScoreDistributionChart.vue?vue&type=script&setup=true&lang=js"
export * from "./ScoreDistributionChart.vue?vue&type=script&setup=true&lang=js"

import "./ScoreDistributionChart.vue?vue&type=style&index=0&id=fa0bf6ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa0bf6ce"]])

export default __exports__